// 1. 引入mock.js


import { options } from 'less'
import Mock from 'mockjs'
import menusList from '@/layout/components/Menu/menus.js'

// 获取mock.Random 对象
const Random = Mock.Random

let categoryNames = [
  "环境治理",
  "家电清洗",
  "衣物护理",
  "家具养护",
  "母婴陪护"
]
let monid = 0
// 用户列表
let userlist = [
  { id: 2, username: 'user', password: 'user123', realName: Random.cname(), date: Random.date() + ' ' + Random.time() },
  { id: 3, username: 'admin1', password: '123321', realName: Random.cname(), date: Random.date() + ' ' + Random.time() },
]

// 拦截登录的请求  axios
// http://47.100.65.29:8002/user/login  /user/userlist /user/userinfo?id=1
Mock.mock('/user/login', 'post', (options) => {
  let params = JSON.parse(options.body)
  for (let i = 0; i < userlist.length; i++) {
    if (params.username === userlist[i].username && params.password === userlist[i].password) {
      monid = i
      return {
        status: 2000,
        message: '登录成功',
        token: 'wqe123safasd123353gasdasad12313'
        
      }
    }
  }
  return {
    status: 1001,
    message: '登录失败,用户名或密码错误'
  }
})

// 栏目列表
let { categoryDatas } = Mock.mock({
  "categoryDatas|20-30": [  // | 20-30 随机生成20-30条数据
    {
      "id|+1": 1, //id自增
      "cateName|+1": 9001, //
      "name|1": categoryNames, // 从栏目名称中随机获取一个
      "icon": Random.image('20x20', "#d8d8d8", '#fff', 'mock'),
      "sortId|+1": 2001,
      "date": Random.date() + ' ' + Random.time()
    }
  ]
})
// 分页请求栏目列表数据
Mock.mock('/category/list', 'post', options => {
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, categoryDatas.length]
  let len = total / pageSize
  //总页数
  const totalPages = len - parseInt(len) > 0 ? parseInt(len) + 1 : len
  // 截取categoryDatas
  const newDatas = categoryDatas.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: {
      list: newDatas,
      total: total,
    }
  }
})

// 添加栏目
Mock.mock('/category/add', 'post', options => {
  if (categoryNames.indexOf(JSON.parse(options.body).name) !== -1) {
    return {
      status: 2001,
      message: '该栏目已存在'
    }
  }
  let obj = {
    id: categoryDatas.length,
    cateName: JSON.parse(options.body).cateName,
    name: JSON.parse(options.body).name,
    icon: JSON.parse(options.body).icon,
    sortId: Random.natural(1, 100),
    date: Random.date() + ' ' + Random.time()
  }
  categoryDatas.unshift(obj)
  let cate = {
    value: JSON.parse(options.body).name,
    label: JSON.parse(options.body).name
  }
  includeList.push(cate)
  return {
    status: 2000,
    message: '添加成功!'
  }
})

//查看栏目详情
Mock.mock('/category/info', 'get', options => {
  let id = JSON.parse(options.body).id
  let newDate = categoryDatas.filter(i => i.id == id)
  return {
    status: 2000,
    data: newDate,
    message: '获取成功'
  }
})

// 删除栏目
Mock.mock('/category/del', 'post', options => {
  let id = JSON.parse(options.body)
  let newDatalist = categoryDatas.filter(i => i.id !== id);
  categoryDatas = newDatalist
  let newdata = includeList.filter(i => i.value !== categoryDatas[id - 1].name)
  includeList = newdata
  return {
    status: 2000,
    message: '删除成功'
  }
})


// 获取用户详情
Mock.mock('/user/info', 'get', options => {
  let id = JSON.parse(options.body).id
  let userData = userlist.filter(i => i.id == id)
  return {
    status: 2000,
    data: userData,
    message: '获取成功'
  }
})

let orderlist = []
for (let i = 0; i < 30; i++) {
  let obj = {
    id: i + 1,
    orderNum: Random.natural(9000, 10000), //随机生成 xx-xx 之间的数
    orderTime: Random.date() + ' ' + Random.time(),
    price: Random.natural(200, 500),
    status: '待派单',
    customId: Random.natural(1, 100),
    employeeId: Random.natural(1, 100),

  }
  orderlist.push(obj)
}
// 分页获取所有订单数据
Mock.mock('/order/list', 'post', options => {
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, orderlist.length]
  let len = total / pageSize
  //总页数
  const totalPages = len - parseInt(len) > 0 ? parseInt(len) + 1 : len
  // 截取categoryDatas
  const newDatas = orderlist.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: {
      list: {
        tableHeader: { orderNum: '订单编号', orderTime: '下单时间', price: '总价', status: '状态', customId: '顾客ID', employeeId: '员工ID' },
        tableData: newDatas,
      },
      total: total,
    }
  }
})

// /order/sendOrder 点击派单的方法
Mock.mock('/order/sendOrder', 'post', options => {
  console.log(options.body);
  console.log(orderlist[0].id);
  for (var i = 0; i < orderlist.length; i++) {
    if (orderlist[i].id == options.body) {
      orderlist[i].status = '待接单'
    }
  }
  return {
    status: 2000,
    message: '派单成功'
  }
})

// 
Mock.mock('/order/resetOrder', 'post', options => {
  console.log(options);
  console.log(orderlist[0].id);
  for (var i = 0; i < orderlist.length; i++) {
    if (orderlist[i].id == options.body) {
      orderlist[i].status = '待派单'
    }
  }
  return {
    status: 2000,
    message: '取消成功'
  }
})

const includeList = []

for (let i = 0; i < categoryNames.length; i++) {
  let obj = {
    value: categoryNames[i],
    label: categoryNames[i],
  }
  includeList.push(obj)
}
function getInclude() {
  return includeList[Random.natural(0, includeList.length - 1)].label
}
let productlist = []
for (let i = 0; i < 15; i++) {
  let obj = {
    id: i + 1,
    ProductNum: Random.natural(9000, 10000), //随机生成 xx-xx 之间的数
    name: Random.cname() + '清洗',
    pict: Random.natural(1, 100),
    // orderTime: Random.date() + ' ' + Random.time(),
    price: Random.natural(200, 500),
    status: Random.pick(['正常', '下架']),
    programa: getInclude(),

  }
  productlist.push(obj)
}
// 分页获取产品数据
Mock.mock('/product/list', 'post', options => {
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, productlist.length]
  let len = total / pageSize
  //总页数
  const totalPages = len - parseInt(len) > 0 ? parseInt(len) + 1 : len
  // 截取categoryDatas
  const newDatas = productlist.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: {
      list: newDatas,
      total: total,
    }
  }
})

//查询获取产品数据
Mock.mock('/product/info', 'post', options => {
  const [pageSize, pageNum] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum]

  let obj = JSON.parse(options.body)
  let sta = obj.value
  let pname = obj.input
  let lanmu = obj.value1
  let total = productlist.length
  let Datas = []

  for (var i = 0; i < productlist.length; i++) {
    if (sta == '') {
      if (pname == '') {
        if (lanmu == '') {
          Datas = productlist
          const newDatas = Datas.slice((pageNum - 1) * pageSize, pageNum * pageSize)
          return {
            status: 2000,
            message: '查询成功',
            data: {
              list: newDatas,
              total: total
            }
          }
        }
        else if (lanmu == productlist[i].programa) {
          Datas.push(productlist[i])
        }
      }
      else if (pname == productlist[i].name) {
        Datas.push(productlist[i])
      }
    }
    else if (sta == productlist[i].status) {
      if (pname == '') {
        if (lanmu == '') {
          Datas.push(productlist[i])
        }
        else if (lanmu == productlist[i].programa) {
          Datas.push(productlist[i])
        }
      }
      else if (pname == productlist[i].name) {
        Datas.push(productlist[i])
      }
    }
  }
  let total1 = Datas.length
  const newDatas1 = Datas.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '查询成功',
    data: {
      list: newDatas1,
      total: total1
    }
  }


})

// 改变状态
Mock.mock('/product/changes', 'post', options => {
  let obj = JSON.parse(options.body)
  console.log(obj.id);

  for (var i = 0; i < productlist.length; i++) {
    if (obj.id == productlist[i].id) {
      if (productlist[i].status == '正常') {
        productlist[i].status = '下架'
      }
      else {
        productlist[i].status = '正常'
      }
    }
  }
  return {
    status: 2000,
    message: '改变成功',
  }
})

// 添加产品信息
Mock.mock('/product/addinfo', 'post', options => {
  let obj = {
    id: productlist.length,
    ProductNum: Random.natural(9000, 10000),
    name: JSON.parse(options.body).name,
    pict: JSON.parse(options.body).pict,
    price: JSON.parse(options.body).price,
    status: JSON.parse(options.body).status,
    programa: JSON.parse(options.body).lanmu,
  }
  productlist.unshift(obj)
  return {
    status: 2000,
    message: '添加成功!'
  }
})

// 获取需要修改的信息
Mock.mock('/product/changeinfo', 'post', options => {
  let obj = JSON.parse(options.body)
  let id = obj.id - 1
  productlist[id].ProductNum = (obj.cateName) ? obj.cateName : productlist[id].ProductNum
  productlist[id].name = (obj.name) ? obj.name : productlist[id].name
  productlist[id].pict = (obj.pict) ? obj.pict : productlist[id].pict
  productlist[id].price = (obj.price) ? obj.price : productlist[id].price
  productlist[id].status = (obj.status) ? obj.status : productlist[id].status
  productlist[id].programa = (obj.lanmu) ? obj.lanmu : productlist[id].programa

  return {
    status: 2000,
    message: '修改成功'
  }
})

// 获取所有栏目的接口
Mock.mock('/product', 'get', options => {
  return {
    status: 2000,
    data: includeList,
    message: '成功'
  }
})

const phonePrefix = ['158', '137', '130', '131', '153']
const index = Math.floor(Math.random() * phonePrefix.length)

let customerlist = []
for (let i = 0; i < userlist.length; i++) {
  let obj = {
    id: i + 1,
    customertNum: Random.natural(100, 200), //随机生成 xx-xx 之间的数
    name: userlist[i].username,
    realname: userlist[i].realName,
    phone: phonePrefix[index] + Mock.mock(/\d{8}/),
    sex: '暂无',
    status: '正常',
  }
  customerlist.push(obj)
}

// 分页获取用户信息
Mock.mock('/customer/list', 'post', options => {
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, customerlist.length]
  let len = total / pageSize
  //总页数
  const totalPages = len - parseInt(len) > 0 ? parseInt(len) + 1 : len
  // 截取categoryDatas
  const newDatas = customerlist.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: {
      list: newDatas,
      total: total,
    }
  }
})

//添加用户信息
Mock.mock('/customer/addinfo', 'post', options => {
  let obj = {
    id: customerlist.length+1,
    customertNum: Random.natural(100, 200),
    name: JSON.parse(options.body).name,
    realname: JSON.parse(options.body).realname,
    phone: JSON.parse(options.body).phone,
    status: JSON.parse(options.body).status,
    sex: JSON.parse(options.body).sex,
  }
  let obj1 = {
    id: userlist.length + 1,
    password: '123456',
    username: JSON.parse(options.body).name,
    realName: JSON.parse(options.body).realname,
    date: Random.date() + ' ' + Random.time()
  }
  customerlist.unshift(obj),
    userlist.push(obj1)
  return {
    status: 2000,
    message: '添加成功!'
  }
})

//编辑用户信息
Mock.mock('/customer/changeinfo', 'post', options => {
  let obj = JSON.parse(options.body)

  for (let id = 0; id < customerlist.length; id++) {
    
    
  if(customerlist[id].id == obj.id){
  customerlist[id].customertNum = (obj.customertNum) ? obj.customertNum : customerlist[id].customertNum
  customerlist[id].name = (obj.name) ? obj.name : customerlist[id].name
  customerlist[id].realname = (obj.realname) ? obj.realname : customerlist[id].realname
  customerlist[id].phone = (obj.phone) ? obj.phone : customerlist[id].phone
  customerlist[id].status = (obj.status) ? obj.status : customerlist[id].status
  customerlist[id].sex = (obj.sex) ? obj.sex : customerlist[id].sex
  }
  }
  return {
    status: 2000,
    message: '修改成功'
  }
})

//查询用户信息
Mock.mock('/customer/info', 'post', options => {
  const [pageSize, pageNum] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum]

  let obj = JSON.parse(options.body)
  let sta = obj.value
  let pname = obj.input
  console.log(sta);
  let total = customerlist.length
  let cdata = []

  for (var i = 0; i < customerlist.length; i++) {
    if (sta == '') {
      if (pname == '') {
        cdata = customerlist
        const newDatas = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
        return {
          status: 2000,
          message: '查询成功',
          data: {
            list: newDatas,
            total: total
          }
        }
      }
      else if (pname == customerlist[i].name) {
        cdata.push(customerlist[i])
      }
    }
    else if (sta == customerlist[i].status) {
      if (pname == '') {
        cdata.push(customerlist[i])
      }
      else if (pname == customerlist[i].name) {
        cdata.push(customerlist[i])
      }
    }
  }

  let total1 = cdata.length
  const newDatas1 = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '查询成功',
    data: {
      list: newDatas1,
      total: total1
    }
  }


})

//删除用户信息
Mock.mock('/customer/delinfo', 'post', options => {
  console.log(options.body);
  let id = JSON.parse(options.body).id
  let newDatalist = customerlist.filter(i => i.id !== id);
  customerlist = newDatalist
  return {
    status: 2000,
    message: '删除成功'
  }

})

let clist = []
let Cnum = []
for (let i = 0; i < 15; i++) {
  let obj = {
    id: i + 1,
    Cname: i + 1,
    Cpice: Random.natural(100, 200),
    Ctime: Random.date() + ' ' + Random.time(),
    Ctype: '提现',
    status: Random.pick(['正常', '异常']),
    Ctalk: Random.word(10),
  }
  Cnum.push(obj.Cname)
  clist.push(obj)
}

// 分页获取用户信息
Mock.mock('/client/list', 'post', options => {
  console.log(clist);
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, clist.length]
  let len = total / pageSize
  //总页数
  const totalPages = len - parseInt(len) > 0 ? parseInt(len) + 1 : len
  // 截取categoryDatas
  const newDatas = clist.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  console.log(newDatas);
  return {
    status: 2000,
    message: '获取数据成功',
    data: {
      list: newDatas,
      total: total,
    }
  }
})

const cclist = []
for (let i = 0; i < Cnum.length; i++) {
  let obj = {
    value: Cnum[i],
    label: Cnum[i],
  }
  cclist.push(obj)
}

// 获取所有栏目的接口
Mock.mock('/client', 'get', options => {
  return {
    status: 2000,
    data: cclist,
    message: '成功'
  }
})

// 查询顾客数据
Mock.mock('/client/getinfo', 'post', options => {
  const [pageSize, pageNum] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum]
  let sta = JSON.parse(options.body).statuvalue
  let total = clist.length
  let cdata = []
  for (var i = 0; i < clist.length; i++) {
    if (sta == '') {
      cdata = clist
      const newDatas = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
      return {
        status: 2000,
        message: '查询成功',
        data: {
          list: newDatas,
          total: total
        }
      }
    } else {
      if (sta == clist[i].status) {
        cdata.push(clist[i])
      }
    }
  }
  let total1 = cdata.length
  const newDatas1 = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '查询成功',
    data: {
      list: newDatas1,
      total: total1
    }
  }

})

let ordcommentlist = []
for (let i = 0; i < 15; i++) {
  let obj = {
    id: i + 1,
    commentinfo: Random.word(10),
    custNum: Random.natural(100, 200),
    customNum: Random.natural(1000, 2000),
    commenttime: Random.date() + ' ' + Random.time(),
    status: Random.pick(['通过', '未审核']),
  }

  ordcommentlist.push(obj)
}

// 分页获取评论信息
Mock.mock('/ordcomment/list', 'post', options => {
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, ordcommentlist.length]
  let len = total / pageSize
  //总页数
  const totalPages = len - parseInt(len) > 0 ? parseInt(len) + 1 : len
  // 截取categoryDatas
  const newDatas = ordcommentlist.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: {
      list: newDatas,
      total: total,
    }
  }
})

// 删除评论信息
Mock.mock('/ordcomment/delinfo', 'post', options => {
  console.log(options.body);
  let id = JSON.parse(options.body).id
  let newDatalist = ordcommentlist.filter(i => i.id !== id);
  ordcommentlist = newDatalist
  return {
    status: 2000,
    message: '删除成功'
  }

})

// 查询评论信息
Mock.mock('/ordcomment/getinfo', 'post', options => {
  const [pageSize, pageNum] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum]
  let sta = JSON.parse(options.body).statuvalue
  let total = ordcommentlist.length
  let cdata = []
  for (var i = 0; i < ordcommentlist.length; i++) {
    if (sta == '') {
      cdata = ordcommentlist
      const newDatas = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
      return {
        status: 2000,
        message: '查询成功',
        data: {
          list: newDatas,
          total: total
        }
      }
    } else {
      if (sta == ordcommentlist[i].status) {
        cdata.push(ordcommentlist[i])
      }
    }
  }
  let total1 = cdata.length
  const newDatas1 = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '查询成功',
    data: {
      list: newDatas1,
      total: total1
    }
  }

})

// 通过操作
Mock.mock('/ordcomment/tonguo', 'post', options => {
  let cid = JSON.parse(options.body).id
  for (let i = 0; i < ordcommentlist.length; i++) {
    if (ordcommentlist[i].id == cid) {
      ordcommentlist[i].status = '通过'
    }
  }
  return {
    status: 2000,
    message: '获取数据成功',
  }
})

// 不通过操作
Mock.mock('/ordcomment/butonguo', 'post', options => {
  console.log(options.body);
  let cid = JSON.parse(options.body).id
  for (let i = 0; i < ordcommentlist.length; i++) {
    if (ordcommentlist[i].id == cid) {
      ordcommentlist[i].status = '未通过'
    }
  }
  return {
    status: 2000,
    message: '获取数据成功',
  }
})


const pinglun = ['真好', '太差了', '太棒了，下次还来', '就没见过这么差的']
let cominfotlist = []
for (let i = 0; i < 15; i++) {
  let obj = {
    id: i + 1,
    cominfo: Random.pick(pinglun),
    comNum: Random.natural(100, 200),
    infoNum: Random.natural(1000, 2000),
    date: Random.date() + ' ' + Random.time(),
    status: Random.pick(['通过', '未审核']),
  }

  cominfotlist.push(obj)
}

// 分页获取评论信息
Mock.mock('/infocon/list', 'post', options => {
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, cominfotlist.length]
  let len = total / pageSize
  //总页数
  const totalPages = len - parseInt(len) > 0 ? parseInt(len) + 1 : len
  // 截取categoryDatas
  const newDatas = cominfotlist.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: {
      list: newDatas,
      total: total,
    }
  }
})

// 通过操作
Mock.mock('/infocon/tonguo', 'post', options => {
  let cid = JSON.parse(options.body).id
  for (let i = 0; i < cominfotlist.length; i++) {
    if (cominfotlist[i].id == cid) {
      cominfotlist[i].status = '通过'
    }
  }
  return {
    status: 2000,
    message: '获取数据成功',
  }
})

// 不通过操作
Mock.mock('/infocon/butonguo', 'post', options => {
  console.log(options.body);
  let cid = JSON.parse(options.body).id
  for (let i = 0; i < cominfotlist.length; i++) {
    if (cominfotlist[i].id == cid) {
      cominfotlist[i].status = '未通过'
    }
  }
  return {
    status: 2000,
    message: '获取数据成功',
  }
})

// 删除评论信息
Mock.mock('/infocon/delinfo', 'post', options => {
  console.log(options.body);
  let id = JSON.parse(options.body).id
  let newDatalist = cominfotlist.filter(i => i.id !== id);
  cominfotlist = newDatalist
  return {
    status: 2000,
    message: '删除成功'
  }
})

// 批量删除评论信息
Mock.mock('/infocon/togdel', 'post', options => {
  let obj = JSON.parse(options.body)
  let n = obj.length
  for (let j = 0; j < n; j++) {
    let newDatalist = cominfotlist.filter(i => i.id !== obj[j].id);
    cominfotlist = newDatalist
  }
  return {
    status: 2000,
    message: '删除成功'
  }
})

let lunbotu = []
for (let i = 0; i < 20; i++) {
  let obj = {
    id: i + 1,
    cateName: Random.natural(9000, 10000), //随机生成 xx-xx 之间的数
    icon: Random.natural(1, 10),
    sortId: Random.natural(1, 100),
    tag: Random.pick('启用', '禁用'),
    // lbstate:['启用','禁用'],
    lbname: '这个轮播图' + Random.pick('很不错', '很好', '很完美',)
  }
  lunbotu.push(obj)
}
// 分页获取轮播数据
Mock.mock('/lunbo/lblist', 'post', options => {
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, lunbotu.length]
  let len = total / pageSize
  //总页数
  const totalPages = len - parseInt(len) > 0 ? parseInt(len) + 1 : len
  // 截取lunbotu
  const newDatas = lunbotu.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: {
      list: newDatas,
      total: total,
    }
  }
})
//查看轮播
Mock.mock('/lunbo/info', 'get', options => {
  let id = JSON.parse(options.body).id
  let newDate = lunbotu.filter(i => i.id == id)
  return {
    status: 2000,
    data: newDate,
    message: '获取成功'
  }
})
//添加轮播
Mock.mock('/lunbo/add', 'post', options => {
  let obj = {
    id: lunbotu.length,
    cateName: JSON.parse(options.body).cateName,
    name: JSON.parse(options.body).name,
    icon: JSON.parse(options.body).icon,
    sortId: Random.natural(1, 100),
    date: Random.date() + ' ' + Random.time()
  }
  lunbotu.unshift(obj)
  return {
    status: 2000,
    message: '添加成功!'
  }
})
//删除轮播
Mock.mock('/lunbo/del', 'post', options => {
  let id = JSON.parse(options.body)
  let newDatalist = lunbotu.filter(i => i.id !== id);
  lunbotu = newDatalist
  return {
    status: 2000,
    message: '删除成功'
  }
})
// 变启用
Mock.mock('/lunbo/xgstatus', 'post', options => {
  let id = JSON.parse(options.body)
  for (let i = 0; i < lunbotu.length; i++) {
    if (lunbotu[i].id == id) {
      lunbotu[i].tag = '启用'
    }
  }
  return {
    status: 2000,
    message: '启用成功',

  }
})
// 变禁用
Mock.mock('/lunbo/xgstatus1', 'post', options => {
  let id = JSON.parse(options.body).id
  console.log(id);
  for (let i = 0; i < lunbotu.length; i++) {
    if (lunbotu[i].id == id) {
      lunbotu[i].tag = '禁用'
    }
  }
  return {
    status: 2000,
    message: '操作成功',

  }
})


// 实名认证数据
let { auditData } = Mock.mock({
  //随机生成20-30条 数据 
  "auditData|20-30": [
    {
      "id|+1": 1, //id自增
      "appNum|+1": 500,
      "name": function () { return Random.cname() },
      "apptime": function () { return Random.datetime("yyyy-MM-dd HH:mm:ss") },
      "idNumber": function () { return Random.id() }, //生成身份证号码
      "idCardForword": Random.image('22x22', "#d8d8d8", '#fff', 'mock'),
      "idCardback": Random.image('22x22', "#d8d8d8", '#fff', 'mock'),
      "bankNum": "@idcard",//@idcard 生成身份证号(在此模拟生成银行卡号)
      "bankCard": function () { return Random.image('22x22', "#d8d8d8", '#fff', 'mock') },
      "status|1": ['通过', '不通过', '未审核']
    }
  ]
})
// 分页请求获取实名认证数据
Mock.mock('/certification/list', 'post', options => {
  let params = JSON.parse(options.body)
  const [pageSize, pageNum, total] = [params.pageSize, params.pageNum, auditData.length]
  // 截取auditData
  const newDatas = auditData.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: newDatas,
    total: total
  }
})
// 通过审核接口
Mock.mock('/certification/pass', 'post', options => {
  let id = JSON.parse(options.body)
  for (let i = 0; i < auditData.length; i++) {
    if (auditData[i].id == id) {
      auditData[i].status = '通过'
    }
  }
  return {
    status: 2000,
    message: '审核通过'
  }
})
// 不通过审核
Mock.mock('/certification/notpass', 'post', options => {
  let id = JSON.parse(options.body)
  for (let i = 0; i < auditData.length; i++) {
    if (auditData[i].id == id) {
      auditData[i].status = '不通过'
    }
  }
  return {
    status: 2000,
    message: '操作成功'
  }
})
// 查询评论信息
Mock.mock('/certification/getinfo', 'post', options => {
  const [pageSize, pageNum] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum]
  let sta = JSON.parse(options.body).statuvalue
  let total = auditData.length
  let cdata = []
  for (var i = 0; i < auditData.length; i++) {
    if (sta == '') {
      cdata = auditData
      const newDatas = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
      return {
        status: 2000,
        message: '查询成功',
        data: {
          list: newDatas,
          total: total
        }
      }
    } else {
      if (sta == auditData[i].status) {
        cdata.push(auditData[i])
      }
    }
  }
  let total1 = cdata.length
  const newDatas1 = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '查询成功',
    data: {
      list: newDatas1,
      total: total1
    }
  }

})

// 资讯列表
let siteDatas = []
for (let i = 0; i < 20; i++) {
  let obj = {
    id: i + 1,
    name: Random.cname() + '资讯', // 随机生成中文名
    sortNum: Random.natural(1, 100),
    describe:Random.word(10)
  }
  siteDatas.push(obj)
}
// 分页请求资讯列表数据
Mock.mock('/siteNews/form', 'post', options => {
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, categoryDatas.length]
  let len = total / pageSize
  //总页数
  const totalPages = len - parseInt(len) > 0 ? parseInt(len) + 1 : len
  // 截取siteDatas
  const newDatas = siteDatas.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: {
      list: newDatas,
      total: total,
    }
  }
})
// 添加资讯
  Mock.mock('/siteNews/addInfo', 'post', options => {
    let obj = {
      id: siteDatas.length,
      name: JSON.parse(options.body).name,
      sortNum: Random.natural(1, 100),
      describe:JSON.parse(options.body).describe
    }
    siteDatas.unshift(obj)
    return {
      status: 2000,
      message: '添加成功!'
    }
})
// 编辑资讯
Mock.mock('/siteNews/edit', 'post', options => {
  let params = JSON.parse(options.body)
  const [id, name, describe, sortNum] = [params.id, params.name, params.describe, params.sortNum]
  for (let i = 0; i < siteDatas.length; i++) {
    if (siteDatas[i].id == id) {
      siteDatas[i].name = name ? name :  siteDatas[i].name 
      siteDatas[i].describe = describe ? describe : siteDatas[i].describe
      siteDatas[i].sortNum = sortNum ? sortNum : siteDatas[i].sortNum
    }
  }
  return {
    status: 2000,
    message: '更新成功'
  }
})
// 删除资讯
Mock.mock('/siteNews/del', 'post', options => {
  let id = JSON.parse(options.body)
  console.log('id',id);
  let newDatalist = siteDatas.filter(i => i.id !== id);
  siteDatas = newDatalist
  return {
    status: 2000,
    message: '删除成功'
  }
})

// 资讯信息
let newsList = []
const newsdata = []
for (let i = 0; i < categoryNames.length; i++) {
  let obj = {
    value: categoryNames[i],
    label: categoryNames[i],
  }
  newsdata.push(obj)
}
// 获取资讯名称
function getnew() {
  return newsdata[Random.natural(0, newsdata.length - 1)].label
}
for (let i = 0; i < 33; i++) {
  let obj = {
    id: i + 1,
    newslnfoNum: Random.natural(9000, 10000), //产品编号 随机生成 xx-xx 之间的数
    name: Random.cname(), //名称
    image: Random.image('18x18', "#d8d8d8", '#fff', 'mock'),
    produtTime: Random.date() + ' ' + Random.time(),
    status: Random.pick(['未审核','推荐','审核通过']),
    include: Random.date() + ' ' + Random.time(), //所属栏目
  }
  newsList.push(obj)
}
// 分页获取所有资讯(按条件检索)
Mock.mock('/newslnfo/list', 'post', options => {
  // 按分页及条件进行查找
  let params = JSON.parse(options.body)
  let newArr = []
  const [pageSize, pageNum] = [params.pageSize, params.pageNum]
  // name 不为空
  if (params.name !== '') {
    if (params.status !== '') {
      if (params.include !== '') {
        newArr = newsList.filter(x => x.status == params.status).filter(x => x.include == params.include).filter(x => x.name = params.name)
        if (newArr.length <= 0) {
          return {
            status: 2001,
            message: '未找到符合条件的数据'
          }
        }
      } else {
        newArr = newsList.filter(x => x.status == params.status).filter(x => x.name == params.name)
        if (newArr.length <= 0) {
          return {
            status: 2001,
            message: '未找到符合条件的数据'
          }
        }
      }
    } else {
      if (params.include !== '') {
        newArr = newsList.filter(x => x.name == params.name).filter(x => x.include == params.include)
        if (newArr.length <= 0) {
          return {
            status: 2001,
            message: '未找到符合条件的数据'
          }
        }
      } else {
        newArr = newsList.filter(x => x.name == params.name)
        if (newArr.length <= 0) {
          return {
            status: 2001,
            message: '未找到符合条件的数据'
          }
        }
      }
    }
  }
  // name为空
  else {
    // status不为空
    if (params.status !== '') {
      // include 不为空
      if (params.include !== '') {
        newArr = newsList.filter(x => x.status == params.status).filter(x => x.include == params.include)
        if (newArr.length <= 0) {
          return {
            status: 2000,
            message: '未找到符合条件的数据'
          }
        }
      }
      // include 为空
      else {
        newArr = newsList.filter(x => x.status == params.status)
        if (newArr.length <= 0) {
          return {
            status: 2000,
            message: '未找到符合条件的数据'
          }
        }
      }
    }
    // status 为空
    else {
      if (params.include !== '') {
        newArr = newsList.filter(x => x.include == params.include)
        if (newArr.length <= 0) {
          return {
            status: 2000,
            message: '未找到符合条件的数据'
          }
        }
      } else {
        newArr = newsList
      }
    }
  }
  const newDatas = newArr.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    data: newDatas,
    total: newArr.length,
    message: '成功'
  }
})

//删除
Mock.mock('/newslnfo/del', 'post', options => {
  let id = JSON.parse(options.body).id
  newsList = newsList.filter(x => x.id !== id)
  return {
    status: 2000,
    message: '删除成功'
  }
})

//审核
Mock.mock('/newslnfo/Eav', 'post', options => {
  let id = JSON.parse(options.body).id
  for (let i = 0; i < newsList.length; i++) {
    if (newsList[i].id == id) {
      newsList[i].status = '审核通过'
    }
  }
  return {
    status: 2000,
    message: '操作成功'
  }  
})

//推荐
Mock.mock('/newslnfo/recom', 'post', options => {
  let id = JSON.parse(options.body).id
  for (let i = 0; i < newsList.length; i++) {
    if (newsList[i].id == id) {
      newsList[i].status = '推荐'
    }
  }
  return {
    status: 2000,
    message: '操作成功'
  }
})

//添加信息
Mock.mock('/newslnfo/add', 'post', options => {
  let params = JSON.parse(options.body)
  const [name, price, status, include] = [params.name, params.price, params.status, params.include]
  let obj = {
    id: newsList.length + 1,
    name: name,
    // price: price,11
    status: status,
    include: include, 
    // productNum: Random.natural(9000, 10000),
    image: Random.image('18x18', "#d8d8d8", '#fff', 'mock'),
    // produtTime: Random.date() + ' ' + Random.time(), // 随机生成时间
  }
  newsList.unshift(obj)
  return {
    status: 2000,
    message: '添加成功'
  }
 
})

// 实名认证数据
let { accountData } = Mock.mock({
  //随机生成20-30条 数据 
  "accountData|20-30": [
    {
      "id|+1": 1, //id自增
      "appNum": 25,
      "apptime": function () { return Random.datetime("yyyy-MM-dd HH:mm:ss") },
      "acctype|1": ['提现', '充值'],
      "accpice":Random.natural(1,100)+'元',
      "accreson|1":['想提现', '想充值','快给我提现','','必须充值'],
      "status|1": ['通过', '不通过', '未审核']
    }
  ]
})
// 分页请求获取实名认证数据
Mock.mock('/account/list', 'post', options => {
  let params = JSON.parse(options.body)
  const [pageSize, pageNum, total] = [params.pageSize, params.pageNum, accountData.length]
  // 截取auditData
  const newDatas = accountData.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: newDatas,
    total: total
  }
})
// 通过审核接口
Mock.mock('/account/pass', 'post', options => {
  let id = JSON.parse(options.body)
  for (let i = 0; i < accountData.length; i++) {
    if (accountData[i].id == id) {
      accountData[i].status = '通过'
    }
  }
  return {
    status: 2000,
    message: '审核通过'
  }
})
// 不通过审核
Mock.mock('/account/notpass', 'post', options => {
  let id = JSON.parse(options.body)
  for (let i = 0; i < accountData.length; i++) {
    if (accountData[i].id == id) {
      accountData[i].status = '不通过'
    }
  }
  return {
    status: 2000,
    message: '操作成功'
  }
})
// 查询评论信息
Mock.mock('/account/getinfo', 'post', options => {
  const [pageSize, pageNum] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum]
  let sta = JSON.parse(options.body).statuvalue
  let total = accountData.length
  let cdata = []
  for (var i = 0; i < accountData.length; i++) {
    if (sta == '') {
      cdata = accountData
      const newDatas = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
      return {
        status: 2000,
        message: '查询成功',
        data: {
          list: newDatas,
          total: total
        }
      }
    } else {
      if (sta == accountData[i].status) {
        cdata.push(accountData[i])
      }
    }
  }
  let total1 = cdata.length
  const newDatas1 = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '查询成功',
    data: {
      list: newDatas1,
      total: total1
    }
  }

})




let user = []
let userrole = ['管理员','顾客','员工']
for (let i = 0; i < 3; i++) {
  let obj = {
    id: i + 1,
    name: userrole[i]
  }
  user.push(obj)
}

// 获取数据
Mock.mock('/userrole/list', 'post', options => {
  return {
    status: 2000,
    message: '获取数据成功',
    data: user,
  }
})

// 编辑角色权限名称
Mock.mock('/userrole/addinfo', 'post', options => {
  let params = JSON.parse(options.body)
  // console.log(params);
  const [id, name,] = [params.id, params.name]
  for (let i = 0; i < user.length; i++) {
    if (user[i].id == id) {
      user[i].name = name ? name :  user[i].name 
    }
  }
  return {
    status: 2000,
    message: '更新成功'
  }
})

// menusList
let rolemanagelist = []

for (let i = 0; i < menusList.length; i++) {
  let obj = {
    id: i + 1,
    name: menusList[i].name,
    route:menusList[i].route,
    type:'meun',
    num:menusList[i].num,
    icon:menusList[i].icon,
    status:'显示',
    children:menusList[i].children
  }
  rolemanagelist.push(obj)
}

// 获取数据
Mock.mock('/rolemanage/list', 'post', options => {
  return {
    status: 2000,
    message: '获取数据成功',
    data: rolemanagelist,
  }
})

//删除用户信息
Mock.mock('/rolemanage/delinfo', 'post', options => {
  console.log(options.body);
  let id = JSON.parse(options.body).id
  let newDatalist = rolemanagelist.filter(i => i.id !== id);
  rolemanagelist = newDatalist
  return {
    status: 2000,
    message: '删除成功'
  }

})

// 添加产品信息
Mock.mock('/rolemanage/addinfo', 'post', options => {
  let obj = {
    id: rolemanagelist.length,
    name: JSON.parse(options.body).name,
    type:JSON.parse(options.body).type,
    num:Random.natural(30,100),
    route: JSON.parse(options.body).route,
    icon: 'icon_'+JSON.parse(options.body).icon,
    status: JSON.parse(options.body).status,
  }
  let men = {
    id : menusList.length+1,
    name: JSON.parse(options.body).name,
    num:Random.natural(30,100),
    icon: 'icon_'+JSON.parse(options.body).icon,
    route: JSON.parse(options.body).route,
  }
  menusList.push(men)
  rolemanagelist.unshift(obj)
  return {
    status: 2000,
    message: '添加成功!'
  }
})

//编辑用户信息
Mock.mock('/rolemanage/changeinfo', 'post', options => {
  let obj = JSON.parse(options.body)

  for (let id = 0; id < rolemanagelist.length; id++) {
    
    
  if(rolemanagelist[id].id == obj.id){
    rolemanagelist[id].name = (obj.name) ? obj.name : rolemanagelist[id].name
    rolemanagelist[id].type = (obj.type) ? obj.type : rolemanagelist[id].type
    rolemanagelist[id].num = (obj.num) ? obj.num : rolemanagelist[id].num
    
    rolemanagelist[id].route = (obj.icrouteon) ? obj.route : rolemanagelist[id].route
    rolemanagelist[id].status = (obj.status) ? obj.status : rolemanagelist[id].status
    if(rolemanagelist[id].icon != obj.icon){
      rolemanagelist[id].icon = (obj.icon) ? 'icon_'+obj.icon : rolemanagelist[id].icon
    }
  }

  if(menusList[id].id == obj.id){
    menusList[id].name = (obj.name) ? obj.name : menusList[id].name
    
    menusList[id].route = (obj.icrouteon) ? obj.route : menusList[id].route
    if(menusList[id].icon != obj.icon){
      menusList[id].icon = (obj.icon) ? 'icon_'+obj.icon : menusList[id].icon
    }
  }
  }
  return {
    status: 2000,
    message: '修改成功'
  }
})



const phonePrefix1 = ['158', '137', '130', '131', '153']
const index1 = Math.floor(Math.random() * phonePrefix1.length)

let yonghulist = []
for (let i = 0; i < 30; i++) {
  let obj = {
    id: i + 1,
    name: Random.name(),
    realname: Random.name(),
    role:'顾客',
    sex: '暂无',
    status: Random.pick(['正常','禁用']),
    phone: phonePrefix1[index1] + Mock.mock(/\d{8}/),
  }
  yonghulist.push(obj)
}

// 分页获取用户信息
Mock.mock('/yonghu/list', 'post', options => {
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, yonghulist.length]
  let len = total / pageSize
  //总页数
  const totalPages = len - parseInt(len) > 0 ? parseInt(len) + 1 : len
  // 截取categoryDatas
  const newDatas = yonghulist.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: {
      list: newDatas,
      total: total,
    }
  }
})

//添加用户信息
Mock.mock('/yonghu/addinfo', 'post', options => {
  let obj = {
    id: yonghulist.length+1,
    role:'顾客',
    name: JSON.parse(options.body).name,
    realname: JSON.parse(options.body).realname,
    phone: JSON.parse(options.body).phone,
    status: JSON.parse(options.body).status,
    sex: JSON.parse(options.body).sex,
  }
  
  yonghulist.unshift(obj)
  return {
    status: 2000,
    message: '添加成功!'
  }
})

//编辑用户信息
Mock.mock('/yonghu/changeinfo', 'post', options => {
  let obj = JSON.parse(options.body)

  for (let id = 0; id < yonghulist.length; id++) {
    
    
  if(yonghulist[id].id == obj.id){
    yonghulist[id].role = (obj.role) ? obj.role : yonghulist[id].role
    yonghulist[id].name = (obj.name) ? obj.name : yonghulist[id].name
    yonghulist[id].realname = (obj.realname) ? obj.realname : yonghulist[id].realname
    yonghulist[id].phone = (obj.phone) ? obj.phone : yonghulist[id].phone
    yonghulist[id].status = (obj.status) ? obj.status : yonghulist[id].status
    yonghulist[id].sex = (obj.sex) ? obj.sex : yonghulist[id].sex
  }
  }
  return {
    status: 2000,
    message: '修改成功'
  }
})

//查询用户信息
Mock.mock('/yonghu/info', 'post', options => {
  const [pageSize, pageNum] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum]

  let obj = JSON.parse(options.body)
  let sta = obj.value
  let pname = obj.input
  console.log(sta);
  let total = yonghulist.length
  let cdata = []

  for (var i = 0; i < yonghulist.length; i++) {
    if (sta == '') {
      if (pname == '') {
        cdata = yonghulist
        const newDatas = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
        return {
          status: 2000,
          message: '查询成功',
          data: {
            list: newDatas,
            total: total
          }
        }
      }
      else if (pname == yonghulist[i].name) {
        cdata.push(yonghulist[i])
      }
    }
    else if (sta == yonghulist[i].status) {
      if (pname == '') {
        cdata.push(yonghulist[i])
      }
      else if (pname == yonghulist[i].name) {
        cdata.push(yonghulist[i])
      }
    }
  }

  let total1 = cdata.length
  const newDatas1 = cdata.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '查询成功',
    data: {
      list: newDatas1,
      total: total1
    }
  }


})

//删除用户信息
Mock.mock('/yonghu/delinfo', 'post', options => {
  console.log(options.body);
  let id = JSON.parse(options.body).id
  let newDatalist = yonghulist.filter(i => i.id !== id);
  yonghulist = newDatalist
  return {
    status: 2000,
    message: '删除成功'
  }

})

// 日志
let { logDatas } = Mock.mock({
  "logDatas|50-60": [
    {
      "id|+1": 1,
      "realName|1": [function () { return Random.cname() }, '杰普'],
      "visitMethod|1": ['get', 'post', 'del'], //访问方式
      "visitUrl": function () { return '/user/' + Random.word(2) },
      "time": function () { return Random.datetime("yyyy-MM-dd HH:mm:ss") }
    }
  ]
})
// 分页获取数据
Mock.mock('/log/list', 'post', options => {
  const [pageSize, pageNum, total] = [JSON.parse(options.body).pageSize, JSON.parse(options.body).pageNum, logDatas.length]
  // 截取
  const newDatas = logDatas.slice((pageNum - 1) * pageSize, pageNum * pageSize)
  return {
    status: 2000,
    message: '获取数据成功',
    data: newDatas,
    total: total
  }
})

let pic = 'user'
Mock.mock('/touxiang/getinfo','post',options =>{
  return {
    status: 2000,
    message: '获取数据成功',
    data: pic,
  }
})

Mock.mock('/touxiang/change','post',options =>{
  pic = 'icon1_'+Random.natural(0,29)
  return {
    status: 2000,
    message: '获取数据成功',
    data: pic,
  }
})


  let obj = {
    id:1,
    name: userlist[monid].username,
    realname: userlist[monid].realName,
    phone: phonePrefix1[index1] + Mock.mock(/\d{8}/),
    sex: '男',
    role:'普通用户',
    dateb:'暂无',
    date:userlist[monid].date,
    email:"暂无",
    status: Random.pick(['正常','禁用']),
  }


  Mock.mock('/info/getinfo','post',options =>{
    
    return {
      status: 2000,
      message: '获取数据成功',
      data: obj,
    }
  })

  Mock.mock('/info/changeinfo','post',options =>{
    let o = JSON.parse(options.body)
    obj = o
    return {
      status: 2000,
      message: '获取数据成功',
      data: obj,
    }
  })


  // 资讯列表
let sysinfolist = []
for (let i = 0; i < 3; i++) {
  let obj = {
    id: i + 1,
    name: Random.cname(),
    zhi: Random.word(10),
    jieshao:Random.word(10),
  }
  sysinfolist.push(obj)
}
// 分页请求资讯列表数据
Mock.mock('/sysinfo/form', 'post', options => {
  
  return {
    status: 2000,
    message: '获取数据成功',
    data:sysinfolist
  }
})
// 添加资讯
  Mock.mock('/sysinfo/addInfo', 'post', options => {
    let obj = {
      id: siteDatas.length,
      name: JSON.parse(options.body).name,
      zhi: JSON.parse(options.body).zhi,
      jieshao:JSON.parse(options.body).jieshao
    }
    sysinfolist.unshift(obj)
    return {
      status: 2000,
      message: '添加成功!'
    }
})
// 编辑资讯
Mock.mock('/sysinfo/edit', 'post', options => {
  let params = JSON.parse(options.body)
  const [id, name, describe, sortNum] = [params.id, params.name, params.zhi, params.jiesaho]
  for (let i = 0; i < sysinfolist.length; i++) {
    if (sysinfolist[i].id == id) {
      sysinfolist[i].name = name ? name :  sysinfolist[i].name 
      sysinfolist[i].zhi = describe ? describe : sysinfolist[i].zhi
      sysinfolist[i].jieshao = sortNum ? sortNum : sysinfolist[i].jieshao
    }
  }
  return {
    status: 2000,
    message: '更新成功'
  }
})
// 删除资讯
Mock.mock('/sysinfo/del', 'post', options => {
  let id = JSON.parse(options.body)
  console.log('id',id);
  let newDatalist = sysinfolist.filter(i => i.id !== id);
  sysinfolist = newDatalist
  return {
    status: 2000,
    message: '删除成功'
  }
})